<template>
  <div class="publication-subscription">
    <AInput label="Введите свой email" />
    <ABtn
      label="Подписаться"
      class="secondary"
    />
  </div>
</template>

<script>
import { AInput, ABtn } from "../../../ui";

export default {
  name: 'PublicationSubscription',
  props: ['result'],
  components: {
    AInput,
    ABtn,
  }
}
</script>

<style lang="scss" scoped>
.publication-subscription {
  display: grid;
  grid-template-columns: 1fr 207px;
  grid-column-gap: 30px;
  margin-bottom: 101px;
  @include tablet{
    grid-column-gap: 14px;
    margin-bottom: 81px;
  }
  @include mobile{
    grid-template-columns: 1fr;
    grid-row-gap: 22px;
    margin-bottom: 60px;
  }
  :deep{
    .field{
      margin-top: 0;
    }
    .label{
      color: #161515;
    }
    .a-btn{
      height: 50px;
      padding: 0 20px;
    }
  }
}
</style>